import React from 'react';
import * as icons from 'react-bootstrap-icons';

import PropTypes from 'prop-types';

import styles from './Buttons.module.css';

export const IconButton = ({ disabled = false, icon, iconColor, marginLeft = false, marginRight = false, marginTop = true, onClick, padding = true, type, size = undefined }) => {

  let Icon = null;
  if(icon !== null){
    Icon = icons[icon];
  }

  return (
    <button type={ type } className={"btn " + styles.customButton + " " + ((padding) ? styles.customIconButton : styles.customIconButtonNoPadding) + " " + ((marginTop) ? " " + styles.customButtonMT : "") + ((marginLeft) ? " " + styles.customButtonML : "") + ((marginRight) ? " " + styles.customButtonMR : "")} onClick={onClick} disabled={disabled}><Icon className={styles.icon} color={iconColor} size={size} /></button>
  )
}

IconButton.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  marginLeft: PropTypes.bool,
  marginRight: PropTypes.bool,
  marginTop: PropTypes.bool,
  onClick: PropTypes.func,
  padding: PropTypes.bool,
  size: PropTypes.number,
  type: PropTypes.oneOf(['button', 'submit']).isRequired,
}